import { useMemo } from "react";
import { WT_STATUS } from "@utils";
import { useCheckEstimateEditorAccess } from "@hooks";
import { useEstimateEditorStore } from "@tools";

export const useWorkTypePermitChecker = (workTypeId) => {
  const editorStore = useEstimateEditorStore();

  const { workTypesWithStatus, estimateUsers } = editorStore || {};

  const { userId, isOwner, isObserver, userGrantedPermits, hasUserGrantedPermits } = useCheckEstimateEditorAccess(estimateUsers, workTypesWithStatus);

  const editionGrant = useMemo(
    () =>
      isOwner ||
      !isObserver ||
      (hasUserGrantedPermits
        ? !!userGrantedPermits?.find((permit) => permit.id === workTypeId)
        : !workTypesWithStatus?.find((permit) => permit.id === workTypeId)
            ?.estimatorUuid),
    [isOwner, userGrantedPermits, workTypesWithStatus]
  );

  const hasPermit = useMemo(
    () =>
      !!workTypesWithStatus?.find(
        (permit) => permit.id === workTypeId && permit.estimatorUuid
      ),
    [workTypesWithStatus]
  );

  const isPending = useMemo(
    () =>
      workTypesWithStatus?.find(
        (permit) => permit.id === workTypeId && permit.estimatorUuid
      )?.status === WT_STATUS.PENDING,
    [workTypesWithStatus]
  );

  const userSeesOnlyPermittedWorkTypes = useMemo(() => (
    hasPermit && editorStore.estimateUserWorkTypeVisibility[userId] === 0
  ), [hasPermit, editorStore.estimateUserWorkTypeVisibility]);

  return {
    isPending,
    hasPermit,
    editionGrant,
    hasUserGrantedPermits,
    userSeesOnlyPermittedWorkTypes,
  };
};
